var map = {
	"./BPPI_estructura.png": 205,
	"./EnlacesDeInteres/banco2.png": 263,
	"./EnlacesDeInteres/secop.png": 445,
	"./EnlacesDeInteres/siac.png": 654,
	"./EnlacesDeInteres/theGlobalGoals.png": 812,
	"./EquipoEvaluador/img1.png": 18,
	"./Proyectos_estandarizados.png": 591,
	"./TarjetasHome/img1.png": 163,
	"./TarjetasHome/img2.png": 460,
	"./TarjetasHome/img3.png": 38,
	"./TarjetasHome/img4.png": 681,
	"./TarjetasHome/img5.png": 349,
	"./TarjetasHome/img6.png": 47,
	"./banner1.png": 665,
	"./footer/footerCo.svg": 763,
	"./footer/footerGov.svg": 898,
	"./footer/footerSGS.svg": 644,
	"./grayTrees.png": 789
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 459;